import apiClient from "./apiClient";

const evaApi = {
  askai: (body = {}) => {
    return apiClient.post(`/api/ai/ask`, body);
  },
  ask_final: (body = {}) => {
    return apiClient.post(`/api/ai/ask-final`, body);
  },
  rate: (body = {}) => {
    return apiClient.post(`/api/ai/rate`, body);
  },
  wtoken: (body = {}) => {
    return apiClient.get(`/api/wtoken`);
  },

  getSession: (sessionId) => {
    return apiClient.get(`/api/report/session?session=${sessionId}`);
  },
  getDocs: ({
    environmentid,
    id,
    sessionid,
  }) => {
    return apiClient.post(`/api/ai/get/docs`, {
      environmentid,
      id,
      sessionid,
    });
  },

  getMessages: (clientId, startDate, endDate) => {
    return apiClient.get(
      `/api/report/getmessages?client_id=${clientId}&start_date=${startDate}&end_date=${endDate}`
    );
  },

  getGroupedMessages: (clientId, startDate, endDate) => {
    return apiClient.get(
      `/api/report/getgroupedmessages?start_date=${startDate}&end_date=${endDate}`
    );
  },
};

export default evaApi;
